import * as React from "react";
import styled from "styled-components";
import { Button, Table, AutoComplete, Select } from "antd";
import { useState, useReducer, useRef, useMemo } from "react";
import { useAuth } from "@/component/Auth";
import {getAllBroadcastNumberRules} from "@/api/virtualRule";
import {
  AnyType,
  BoolType,
  ConfefenctType,
  ConferenceInterface,
} from "@/types";
import { SettingOutlined, NotificationOutlined } from "@ant-design/icons";
import { Tooltip, Modal, Input } from "antd";
import NumericInput from "../../../component/MyInput/MyInput";
// import Rtm from "@/hooks/use-rtm";
//import useRtm from "@/hooks/use-rtm";
import {useRTM} from "@/component/Rtm";
import { storage } from "@/util";
import {
  LOGININFOSTORE,
  METTINGPAGE_SAVED_MEETING_INFO,
  NORMALSETTINGKEY,
  LOGINTOKEN
} from "@/config/const";
import { conference, users } from "@/api";
import { time } from "@/util";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Message } from "@/qrtc_web_rtm/protoo-client/Message";
import { message } from "antd";
import isElectron from "is-electron";
import { deleteUser, deptlists, syncDeleteRtcWebmgrUsers, userlists } from "@/api/users";
import create from "./create";
import Create from "./create";
import item from "@/component/board/WhiteBoard/footer/item";
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 12px 12px 0;
  margin-bottom: 10px;
  .header {
    font-size: 16px;
    font-weight: 400;
    color: #999;
    height: 30px;
    position: relative;
    width: 85%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;

  }
  .main {
    flex: 1;
    overflow-y: auto;
    width: 100%;
    /* padding: 5px 10px; */
    border: 1px solid #eee;
    border-radius: 3px;
  }
  .footer {
    height: 50px;
    display: flex;
    flex-direction: line;
    justify-content: center;
    align-items: center;
    width: 100%;
    .cancel {
      margin-left: 70px;
    }
  }
`;

export const useDepts = () => {
  const [depts, setDepts] = useState<any[]>([]);
  React.useEffect(() => {
    deptlists()
      .then((data) => {
        const rows = Array.isArray(data?.rows) ? data.rows : [];
        const options = rows.map((dept: any) => ({
          ...dept,
          value: Number(dept.deptId),
          label: dept.deptName,
          disabled: String(dept.status) === "0",
        }));
        setDepts(options);
      })
      .catch((error) => {
        console.error("Failed to load meeting departments", error);
        setDepts([]);
      });
  }, [])
  return {depts}
}
// localStorage
const Users: React.FunctionComponent = () => {
  const history = useHistory();
  // const rtm = useRtm({}, (closedByServer)=>{
  //   console.log("[Login] closedByServer", closedByServer);
  //   //关闭rtm
  //   rtm.logout();
  //   //退出登录
  //   storage.remove(LOGININFOSTORE);
  //   storage.remove(LOGINTOKEN);
  //   if (isElectron()) {
  //     alert(`推出登陆!`);
  //     history.replace("/");
  //   } else {
  //     window.location.href = "/";
  //   }
  //   alert("检测到相同账号重复登录，已自动退出!");
  // });
  const {
    isRTMConnected,
    addEventListener,
    removeEventListener } = useRTM();
  const [tableData, setTableData] = React.useState<AnyType[]>([]);
  const auth = useAuth();
  const presenceEve = (evt: any) => {
    const {
      action = "",
      channelName = "",
      channelType = "",
      publisher = "",
    } = evt;
    //
    if (
      action.toLowerCase() === "remote_join" &&
      channelName.toLowerCase() === "notification" &&
      channelType.toLowerCase() === "message"
    ) {
      //
      const act = tableData.find((x) => x.id === publisher);
      if (!act) {
        setTableData([...tableData, { id: publisher }]);
      }
    }
  };

  const [allusers, setAllUsers] = useState<any[]>([]);
    const mineInfo = JSON.parse(
      window.localStorage.getItem(LOGININFOSTORE) || "{}"
    );

    const meeting = useRef<any>({});

    const getAllUsers = React.useCallback(async () => {
      const res = await userlists({});
  
      const arr = res.users.filter(
        (item: any) => item.account !== mineInfo.username
      ).map((item: any) => ({
        ...item,
        id: item.userId,
      }));

      console.log("getAllUsers", arr);
      setAllUsers(arr);
    }, []);

    const [dept, setDept] = useState<number>(100);

  const { depts } = useDepts()

  const filterUser = useMemo(() => {
    const filterDept = depts.filter(item => item.ancestors.includes(dept) || item.deptId === dept);

    const deptStr = filterDept.map((item: any) => item.value).join(",")

    return allusers.filter(item =>deptStr.includes(item.deptId));
  },[dept, allusers])

  const handleDel = async (userId: string, account?: string, phone?: string) => {
    try {
      const res = await deleteUser(userId);
      const accounts = [account, phone].filter((v) => !!v) as string[];
      if (accounts.length > 0) {
        try {
          await syncDeleteRtcWebmgrUsers(accounts);
        } catch (syncErr) {
          console.warn("syncDeleteRtcWebmgrUsers failed:", syncErr);
          message.warning("会议侧已删除，平台侧同步删除失败，请稍后重试");
        }
      }

      console.log("handleDel", res);
      message.success("删除成功");
      getAllUsers();
    } catch (error) {
      message.error("删除失败 请稍后再试");
    }
  };

  const tableColumns1 = [
    {
      title: "登录账户",
      dataIndex: "account",
      ellipsis: true,
      render: (text: string) => {
        return (
          <Tooltip title={text} placement="topLeft">
            <span>{text}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "姓名",
      dataIndex: "nickname",
      ellipsis: true,
      render: (text: string) => {
        return (
          <Tooltip title={text} placement="topLeft">
            <span>{text}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "电话",
      dataIndex: "phone",
      ellipsis: true,
    },
    {
      title: "部门",
      dataIndex: "deptName",
      ellipsis: true,
    },
    {
      title: "类型",
      dataIndex: "platformType",
      ellipsis: true,
    },
    {
      title: "操作",
      width: "15%",
      render: (_: any, record: any) => (
        <div className="fac">
          {/* <Button
            size="small"
            type="link"
            className="w50"
            onClick={() => { console.log("编辑用户", record); }  }
          >
            编辑
          </Button> */}
          <Button
            size="small"
            type="link"
            danger
            className="w50"
            onClick={() => { handleDel(record.id, record.account, record.phone); }}
          >
            删除
          </Button>
        </div>
      ),
    },
  ];

  React.useEffect(() => {
    getAllUsers();
  }, []);

  React.useEffect(() => {
    if(isRTMConnected){
    addEventListener("presence", presenceEve);
    //addEventListener("message", messageEve);
    }
    getAllUsers();
    return () => {
      removeEventListener("presence", presenceEve);
      //removeEventListener("message", messageEve);
  };
  }, [isRTMConnected]);

  const [createVisible, setCreateVisible] = useState(false);

  return (
    <Container>

      {createVisible && (<Create cancel={() => { setCreateVisible(false); getAllUsers(); }} />)}

      <div className="header">
        <span>用户管理</span>
        <Button
          type="link"
          onClick={() => {
            setCreateVisible(true);
          }}
        >
          新增用户
        </Button>
      </div>
      <div style={{ marginBottom: 10  ,width: "100%"}}>
        <Select value={dept} onSelect={setDept} options={depts} style={{ width: "160px"}} />
      </div>
        <Table
          columns={tableColumns1}
          dataSource={filterUser}
          rowKey="id"
          size="small"
          pagination={false}
          scroll={{ y: 460 }}
        />
    </Container>
  );
};

export default Users;
